<template>
  <div class="page-challenge-detail">
    <div v-if="challenge"
         class="header"
    >
      <div class="title">挑战{{ challenge.seq }}：{{ challenge.title }}</div>
      <div class="summary"
           v-html="challenge.content"
      ></div>
    </div>
    <work-list-block :next-start="start"
                     :works="list"
                     :target-id="id"
                     target-type="challenge"
    />
  </div>
</template>

<script>
  import { getChallengeDetail } from '@/services/course';
  import { LIMIT } from '@/utils/constant';
  import WorkListBlock from '@/pages/Challenge/components/WorkListBlock';

  export default {
    name: 'ChallengeDetail',
    metaInfo() {
      return {
        title: this.pageTitle,
      };
    },
    components: {
      WorkListBlock,
    },
    data() {
      return {
        pageTitle: '',
        challenge: null,
        list: [],
        start: 0,
      };
    },
    computed: {
      id() {
        return parseInt(this.$route.params.id, 10);
      },
    },
    methods: {
      async fetchData() {
        const data = await getChallengeDetail({
          limit: LIMIT,
          start: this.start,
          id: this.id,
        });
        this.pageTitle = data.challenge.title;
        this.challenge = data.challenge;
        this.list = data.list;
        this.start = data.start;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .header {
    background: @color-white;
    padding: 0 @size-base;
  }

  .title {
    padding: @size-base 0;
    border-bottom: @border-base;
    color: @color-text-base;
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
  }

  .summary {
    padding: @size-small + @size-extra-small / 2 0;
    color: @color-text-light;
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
    line-height: 1.6;
  }

</style>
